var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeaker = function SvgBeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.2 6.07V1.4H5.5v4.68l-3.4 9.45c-.3.81.17 1.47 1.04 1.47h9.44c.88 0 1.34-.66 1.05-1.47L10.2 6.07Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.34 1.39h7.03M3.95 11.54s1.36 1.08 3.72 0a4.47 4.47 0 0 1 4.09 0",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgBeaker;